import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DivButton from 'GeneralUI/DivButton/DivButton.jsx'
import { xtractAPI } from 'actions/apiActions'
import { addToClickLog } from 'actions/logActions'

const UrgentNotificationBanner = () => {
  const [notification, setNotification] = useState()
  const loggedIn = useSelector(state => state.auth?.token != null)
  const banners = (
    useSelector(
      state => state.user?.notification_metadata?.urgent_notifications
    ) || []
  ).filter(notification => notification.type === 'banner')
  const bannerRef = useRef()
  const timerRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    // componentDidMount
    return () => {
      // component will unmount
      clearTimeout(timerRef.current)
    }
  }, [])

  useEffect(() => {
    if (!notification && banners.length > 0) {
      dispatch(addToClickLog({ event: `Banner: ${banners[0].subject}` }))
      setNotification(banners[0])
    } else if (
      notification &&
      banners &&
      banners.findIndex(
        banner => banner.notification_id === notification.notification_id
      ) === -1
    ) {
      // this should happen but on the off chance a notification is howing that is no longer in banners, we should clear it from the screen
      setNotification(null)
    }
  }, [banners, notification])

  const closer = useCallback(() => {
    if (!notification) {
      if (bannerRef.current) {
        bannerRef.current.classList.remove('animate__slideInDown')
        bannerRef.current.classList.add('animate__slideOutUp')
        timerRef.current = setTimeout(() => {
          setNotification(null)
        }, 750)
      } else {
        setNotification(null)
      }
      return
    }
    dispatch(
      xtractAPI(
        `me/notification/${notification.notification_id}`,
        'delete',
        {
          notification_id: notification.notification_id,
          read_at: true
        },
        {
          200: () => {
            if (bannerRef.current) {
              bannerRef.current.classList.remove('animate__slideInDown')
              bannerRef.current.classList.add('animate__slideOutUp')
              timerRef.current = setTimeout(() => {
                setNotification(null)
              }, 750)
            } else {
              setNotification(null)
            }
          },
          404: () => {
            if (bannerRef.current) {
              bannerRef.current.classList.remove('animate__slideInDown')
              bannerRef.current.classList.add('animate__slideOutUp')
              timerRef.current = setTimeout(() => {
                setNotification(null)
              }, 750)
            } else {
              setNotification(null)
            }
          } //if its not there anymore we dont need to worry about deleting it
        }
      )
    )
  }, [bannerRef.current, notification, timerRef.current])

  if (!loggedIn || !notification) {
    return null
  } else {
    return (
      <div
        ref={bannerRef}
        className="urgent-notification-banner animate__animated animate__slideInDown animate__faster"
      >
        <div className="icon-area">
          <FontAwesomeIcon icon={['fas', 'triangle-exclamation']} />
        </div>
        <div className="message-area">
          <div className="subject">{notification.subject}</div>
          <div className="body">{notification.body}</div>
          <div className="timestamp">{notification.created_at}</div>
        </div>
        <div className="dismiss">
          <DivButton
            aria-label="dismiss alert button"
            onClick={closer}
            className="btn btn-danger"
          >
            Dismiss
          </DivButton>
        </div>
      </div>
    )
  }
}

export default UrgentNotificationBanner
